import t from "styled-components";
const o = t.div`
  display: flex;
  flex-grow: 1;
  position: relative;
  width: 100%;
`;
export {
  o as InputInterior
};
